import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';

import { Container, DiagnosisContainer, Title, Description, Button } from '../Common/Common.style';
import MultipleChecker from '../Common/MultipleChecker/MultipleChecker'
import SingleChecker from '../Common/SingleChecker/SingleChecker'
import DiagnosisStep from '../DiagnosisStep/DiagnosisStep';
import { ErrorMessage, QuestionTitle, QuestionSubTitle, CtaButton } from './UserSurveyPage.style';
import Placeholder from '../../../../components/Placeholder';
import { TABLET_P } from '../../../../constants';

import { saveSublimicStylistDiagnosis } from '../../../../redux/actions/sublimicDiagnosis';
import { setScalpCameraPinCode } from '../../../../redux/actions/scalpCameraDiagnosis';
import { saveSublimicUserSurvey } from '../../../../redux/actions/sublimicDiagnosis';

class UserSurveyPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      result: [],
      errorRequired: {},
      isLoadResult: false,
    };

    // ストレージからstylistDiagnosisResultsを再現
    const stylistDiagnosisResults = JSON.parse(localStorage.getItem('storeStylistDiagnosisResults'));
    if (stylistDiagnosisResults && stylistDiagnosisResults.result) {
      // console.log('ストレージからstylistDiagnosisResultsを再現', stylistDiagnosisResults);  
      this.props.saveSublimicStylistDiagnosis(stylistDiagnosisResults.result);
    }
    // ストレージからpinCodeを再現
    const pinCode = JSON.parse(localStorage.getItem('storePinCode'));
    if (pinCode) {
      // console.log('ストレージからpinCodeを再現', pinCode);  
      this.props.setScalpCameraPinCode(pinCode);
    }
    // ストレージからuserSurveyResultを再現
    const userSurveyResult = JSON.parse(localStorage.getItem('storeUserSurveyResult'));
    if (userSurveyResult && userSurveyResult.result) {
      // console.log('ストレージからuserSurveyResultを再現', userSurveyResult);  
      this.props.saveSublimicUserSurvey(userSurveyResult.result);
    }
  }

  componentWillMount() {
    this.setValidateData();
  }

  componentDidUpdate() {
    this.setValidateData();
    this.loadResultData();
  }

  componentDidMount() {
    this.loadResultData();
    window.addEventListener('scroll', () => this.loseFocusAllInput(), false);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', () => this.loseFocusAllInput(), false);
  }

  loseFocusAllInput() {
    let el = document.querySelector( ':focus' );
    if( el ) el.blur();
  }

  setValidateData = () => {
    const { userSurvey } = this.props;
    const { questions } = userSurvey;
    if (!questions || this.state.result.length > 0) return;
    const slugs = [];
    questions.map(question => {
      if (question.contentType === "userSurveyQuestionCategory") {
        const data = {
          contentType: question.contentType,
          type: "Question Category",
          slug: question.slug,
          questions: [],
        };
        question.questions.map(q => {
          const childData = {
            type: "Fixed Question",
            slug: q.slug,
            multipleAnswer: q.multipleAnswer,
            answers: [],
            freeDescriptionAnswer: "",
            includeFreeDescription: !!q.includeFreeDescription,
            validationTypes: q.validationTypes || [],
          }
          data.questions.push(childData)
        });
        slugs.push(data);
      } else {
        const data = {
          contentType: question.contentType,
          type: "Fixed Question",
          slug: question.slug,
          multipleAnswer: question.multipleAnswer,
          answers: [],
          freeDescriptionAnswer: "",
          includeFreeDescription: !!question.includeFreeDescription,
          validationTypes: question.validationTypes || [],
        };
        slugs.push(data)
      }
    });
    this.setState({
      result: [...slugs],
    })
  };

  loadResultData = () => {
    const { sublimicDiagnosis } = this.props;
    const { result, isLoadResult } = this.state;
    let { errorRequired } = this.state;
    if(sublimicDiagnosis.userSurveyResult && sublimicDiagnosis.userSurveyResult.result &&
      sublimicDiagnosis.userSurveyResult.result.length > 0 && result.length > 0 && !isLoadResult) {
      const sublimicDiagnosiUserSurveyResult = sublimicDiagnosis.userSurveyResult.result;
      const slugs = [];
      result.map(question => {
        if (question.contentType === "userSurveyQuestionCategory") {
          const data = {
            contentType: question.contentType,
            type: "Question Category",
            slug: question.slug,
            questions: [],
          };
          question.questions.map(q => {
            const childData = {
              type: "Fixed Question",
              slug: q.slug,
              answers: [],
              freeDescriptionAnswer: "",
              includeFreeDescription: !!q.includeFreeDescription,
              validationTypes: q.validationTypes || [],
            }
            const foundResult = this.findQuestionResult(q.slug, sublimicDiagnosiUserSurveyResult);
            if(foundResult && foundResult.slug) {
              childData.answers = foundResult.answers;
              childData.freeDescriptionAnswer = foundResult.freeDescriptionAnswer;
              foundResult.answers.map(answerSlug => {
                let element = q.multipleAnswer ? document.getElementById(answerSlug) : document.getElementById(`a${answerSlug}_${q.slug}`);
                element && (element.checked = true);
              });
              let elementText = document.getElementById(`${q.slug}-free-text`);
              elementText && (elementText.value = foundResult.freeDescriptionAnswer);

              if(errorRequired.hasOwnProperty(q.slug)){
                delete errorRequired[q.slug];
              }
            }
            data.questions.push(childData)
          });
          slugs.push(data);
        } else {
          const data = {
            contentType: question.contentType,
            type: "Fixed Question",
            slug: question.slug,
            answers: [],
            freeDescriptionAnswer: "",
            includeFreeDescription: !!question.includeFreeDescription,
            validationTypes: question.validationTypes || [],
          };
          const foundResult = this.findQuestionResult(question.slug, sublimicDiagnosiUserSurveyResult);
          if(foundResult && foundResult.slug) {
            data.answers = foundResult.answers;
            data.freeDescriptionAnswer = foundResult.freeDescriptionAnswer;
            foundResult.answers.map(answerSlug => {
              let element = question.multipleAnswer ? document.getElementById(answerSlug) : document.getElementById(`a${answerSlug}_${question.slug}`);
              element && (element.checked = true);
            });
            let elementText = document.getElementById(`${question.slug}-free-text`);
            elementText && (elementText.value = foundResult.freeDescriptionAnswer);

            if(errorRequired.hasOwnProperty(question.slug)){
              delete errorRequired[question.slug];
            }
          }
          slugs.push(data)
        }
      })
      this.setState({
        isLoadResult: true,
        result: [...slugs],
        errorRequired,
      })
    }
  }

  next = () => {
    const { history, saveSublimicUserSurvey } = this.props;
    const { result } = this.state;
    // TODO: スカルプカメラ連携は Phase 2 対象外。以下の処理は、後で必要があれば復活させる。
    // const path = this.useCamera() ? './scalp-camera' : './stylist-diagnosis';
    this.loseFocusAllInput();
    if (this.validate()) {
      saveSublimicUserSurvey(result);

      if (result) {
        // ストレージにuserSurveyResultを保存
        const userSurveyResult = { result: result }
        // console.log('ストレージにuserSurveyResultを保存', userSurveyResult);
        localStorage.setItem('storeUserSurveyResult', JSON.stringify(userSurveyResult));
      }
      // TODO: スカルプカメラ連携は Phase 2 対象外。以下の処理は、後で必要があれば復活させる。
      // history.push(path);
      history.push('stylist-diagnosis');
    }
  };

  useCamera = () => {
    const { authSalonSettings } = this.props;
    if (authSalonSettings && authSalonSettings.others && authSalonSettings.others.useCamera) {
      return authSalonSettings.others.useCamera.toLowerCase() === 'true';
    }
    return false;
  };

  findQuestionResult = (slug, result) => {
    let foundQuestion = null;
    result.map(question => {
      if (question.questions) {
        question.questions.map(q => {
          if (q.slug === slug) {
            foundQuestion = q;
          }
        })
      } else {
        if (question.slug === slug) {
          foundQuestion = question;
        }
      }
    });
    return foundQuestion;
  };

  validate = () => {
    const { result } = this.state;
    let error = {};
    result.map(item => {
      if (item.contentType === "userSurveyFixedQuestion") {
        if (item.validationTypes && item.validationTypes.find(value => value === "Required")) {
          if (item.answers.length === 0) {
            error[item.slug] = true;
            if (item.includeFreeDescription && item.freeDescriptionAnswer !== "") {
              delete error[item.slug];
            }
          }
        }
      } else {
        item.questions.map(question => {
          if (question.validationTypes && question.validationTypes.find(value => value === "Required")) {
            if (question.answers.length === 0){
              error[question.slug] = true;
              if (question.includeFreeDescription && question.freeDescriptionAnswer !== "") {
                delete error[question.slug];
              }
            }
          }
        })
      }
    });
    this.setState({ errorRequired: error });
    return Object.keys(error).length <= 0;
  };

  handleChecked = (e, parentQuestion, answer) => {
    const { userSurvey } = this.props;
    let matchQuestion;
    this.state.result.map(question => {
      if (question.slug === parentQuestion.slug) {
        matchQuestion = question;
        return;
      } else {
        if (question.questions) {
          question.questions.map(q => {
            if (q.slug === parentQuestion.slug) {
              matchQuestion = q;
              return;
            }
          })
        }
      }
    });
    if (matchQuestion === undefined) return;
    if (e.target.checked) {
      if (!parentQuestion.multipleAnswer) {
        matchQuestion.answers = [];
      }
      matchQuestion.answers.push(answer.slug);
    } else {
      const answerIndex = matchQuestion.answers.findIndex(value => value === answer.slug);
      matchQuestion.answers.splice(answerIndex, 1);
    }

    // 選択した設問が既にエラーが出ていれば非表示にする
    if(e.target.checked && this.state.errorRequired.hasOwnProperty(e.target.name)){
      let error = this.state.errorRequired;
      delete error[e.target.name];
      this.setState({ errorRequired: error });
    }
  };

  handleInput = (e, parentQuestion) => {
    let matchQuestion = null;
    this.state.result.map(question => {
      if (question.slug === parentQuestion.slug) {
        matchQuestion = question;
        return;
      } else {
        if (question.questions) {
          question.questions.map(q => {
            if (q.slug === parentQuestion.slug) {
              matchQuestion = q;
              return;
            }
          })
        }
      }
    });
    if (matchQuestion === undefined) return;
    matchQuestion.freeDescriptionAnswer = e.target.value;

    // 選択した設問が既にエラーが出ていれば非表示にする
    if(e.target.value !== "" && this.state.errorRequired.hasOwnProperty(e.target.name)){
      let error = this.state.errorRequired;
      delete error[e.target.name];
      this.setState({ errorRequired: error });
    }
  };

  getDiagnosisStep = () => {
    // TODO: スカルプカメラ連携は Phase 2 対象外。以下の処理は、後で必要があれば復活させる。
    // const useCamera = !!this.useCamera();
    const skippedUserSurvey = !!localStorage.getItem('sublimic-skippedUserSurvey');
    let pageNumber = 1;
    let maxNumber = 1;

    // TODO: スカルプカメラ連携は Phase 2 対象外。以下の処理は、後で必要があれば復活させる。
    // if (useCamera && !skippedUserSurvey) {
    //   pageNumber = 1;
    //   maxNumber = 3;
    // } else if (useCamera && skippedUserSurvey) {
    //   pageNumber = 1;
    //   maxNumber = 2;
    // } else if (!useCamera && !skippedUserSurvey) {
    //   pageNumber = 1;
    //   maxNumber = 2;
    // } else if (!useCamera && skippedUserSurvey) {
    //   pageNumber = 1;
    //   maxNumber = 1;
    // }

    if (!skippedUserSurvey) {
      pageNumber = 1;
      maxNumber = 2;
    } else {
      pageNumber = 1;
      maxNumber = 1;
    }

    return maxNumber > 1 ? <DiagnosisStep pageNumber={pageNumber} maxNumber={maxNumber} /> : null;
  };

  render() {
    const { userSurvey, copy } = this.props;
    const { errorRequired } = this.state;
    const { title, description, questions } = userSurvey;
    return (
      <Container>
        {this.getDiagnosisStep()}
        <DiagnosisContainer>
          <Title>{title && title ? title : <Placeholder w={window.innerWidth > TABLET_P ? '300px' : '220px'} h={window.innerWidth > TABLET_P ? '28px' : '20px'} />}</Title>
          {description && description ? (
            <Description dangerouslySetInnerHTML={{__html: description.replace("\n", "<br />")}} />
          ) : (
            <Description>
              <Placeholder w={window.innerWidth > TABLET_P ? '500px' : '225px'} h="54px" />
            </Description>
          )}
          {questions && questions.map(question => (
            <React.Fragment key={question.entryId}>
              {question.contentType === "userSurveyFixedQuestion" ? (
                <React.Fragment>
                  <QuestionTitle>{question.title && question.title ? question.title : <Placeholder w="120px" h="30px" />}</QuestionTitle>
                  {!_.get(question, 'answers') ?
                    <Placeholder w="100%" h="300px" /> : (
                      <React.Fragment>
                        {question.multipleAnswer
                          ? <MultipleChecker question={question} handleChecked={this.handleChecked} handleInput={this.handleInput} key={question.slug} />
                          : <SingleChecker question={question} handleChecked={this.handleChecked} handleInput={this.handleInput} key={question.slug} />
                        }
                      </React.Fragment>
                    )
                  }
                  {errorRequired[question.slug] ? <ErrorMessage>{copy.errorMessage && copy.errorMessage.inputRequired}</ErrorMessage> : null}
                </React.Fragment>
              ) : (
                <React.Fragment>
                  <QuestionTitle>{question.title && question.title ? question.title : <Placeholder w="120px" h="30px" />}</QuestionTitle>
                  {!_.get(question, 'questions') ?
                    <Placeholder w="100%" h="300px" /> : (
                      <React.Fragment>
                        {question.questions.map(question => (
                          <React.Fragment key={question.entryId}>
                            <QuestionSubTitle>{question.title}</QuestionSubTitle>
                            {question.multipleAnswer
                              ? <MultipleChecker question={question} handleChecked={this.handleChecked} handleInput={this.handleInput} key={question.slug} />
                              : <SingleChecker question={question} handleChecked={this.handleChecked} handleInput={this.handleInput} key={question.slug} />
                            }
                            {errorRequired[question.slug] ? <ErrorMessage>{copy.errorMessage && copy.errorMessage.inputRequired}</ErrorMessage> : null}
                          </React.Fragment>
                        ))}
                      </React.Fragment>
                    )
                  }
                </React.Fragment>
              )}
            </React.Fragment>
          ))}
          <CtaButton>
            {copy.sublimicDiagnosis && copy.sublimicDiagnosis.nextBtn && <Button onClick={this.next} className="userSurveyPage">{copy.sublimicDiagnosis.nextBtn}</Button>
            || <Placeholder m="auto" w={window.innerWidth > TABLET_P ? '300px' : '100%'} h={window.innerWidth > TABLET_P ? '58px' : '48px'} style />}
          </CtaButton>
          {Object.keys(errorRequired).length > 0 ? <ErrorMessage>{copy.sublimicDiagnosis && copy.sublimicDiagnosis.errorRequired}</ErrorMessage> : null}
        </DiagnosisContainer>
      </Container>
    );
  }
}

UserSurveyPage.defaultProps = {
  copy: {},
  authSalonSettings: {},
};
UserSurveyPage.propTypes = {
  copy: PropTypes.shape(),
  userSurvey: PropTypes.shape(),
  authSalonSettings: PropTypes.shape(),
};
const mapState = state => ({
  copy: state.salonConsultaionSiteOptions.siteCopy,
  locale: state.locale,
  sublimicDiagnosis: state.sublimicDiagnosis,
  userSurvey: state.userSurvey,
  authSalonSettings: state.authSalonSettings,
});

const mapDispatch = dispatch => ({
  saveSublimicStylistDiagnosis: data => dispatch(saveSublimicStylistDiagnosis(data)),
  setScalpCameraPinCode: (pin) => dispatch(setScalpCameraPinCode(pin)),
  saveSublimicUserSurvey: data => dispatch(saveSublimicUserSurvey(data)),
});

export default connect(mapState, mapDispatch)(UserSurveyPage);



// WEBPACK FOOTER //
// ./src/pages/SalonConsultationPage/SublimicDiagnosisPage/UserSurveyPage/UserSurveyPage.js